module.exports = __webpack_public_path__ + "images/straight-fire-gif-2.gif";